import {Component, OnInit} from '@angular/core';

import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NzModalService} from 'ng-zorro-antd';
import {Subject} from 'rxjs';
import {AccountInfoService} from 'src/app/services/business/account-info/account-info.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {UploadService} from '../../services';
import {UploaderComponent} from "../../shared";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss']
})
export class AccountInfoComponent implements OnInit {
  phone;
  unsubscribe$ = new Subject<void>();
  form = this.fb.group({
    fistName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    phone: ['', [Validators.required]],
    email: ['', [Validators.pattern('[a-z0-9_\\.]{1,32}@[a-z0-9]{2,}(\\.[a-z0-9]{2,4}){1,2}$')]],
    avatar: '',
  });
  avatar: any[] = [];
  loading = false;
  constructor(
    private fb: FormBuilder,
    private modalService: NzModalService,
    private accountService: AccountInfoService,
    private notification: NzNotificationService,
    private uploadService: UploadService
  ) {
  }
  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.loadData();
  }

  loadData() {
    this.accountService.info().subscribe(
      res => {
        if (res.code === 1) {
          const data = res.data;
          this.form.get('fistName').setValue(data.fistName);
          this.form.get('lastName').setValue(data.lastName);
          this.form.get('phone').setValue(data.phone);
          if (data.phone != null) {
            this.form.controls.phone.disable();
          }
          this.form.get('email').setValue(data.email);
          if (data.email != null) {
            this.form.controls.email.disable();
          }
          if (data.avatar) {
            const avatar$ = {
              name: 'avatar',
              type: 'jpeg',
              url: data.avatar,
            };
            this.avatar.push(avatar$);
          }
          this.form.get('avatar').setValue(data.avatar);
        } else {
          this.notification.create(
            'error',
            'Lấy thông tin tài khoản thất bại',
            res.message
          );
        }
      },
      error => {
        this.notification.create(
          'error',
          'Lấy thông tin tài khoản thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  update() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    const fistName$ = this.form.get('fistName').value;
    const lastName$ = this.form.get('lastName').value;
    const email$ = this.form.get('email').value;
    const phone$ = this.form.get('phone').value;
    const body = {
      firstName: fistName$,
      lastName: lastName$,
      phone: phone$,
      email: email$,
      avatar: this.avatar.length ? this.avatar[0].url : '',
    };
    this.accountService.update(body).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Cập nhật thông tin tài khoản thành công'
          );
          const name$ = fistName$ + lastName$;
          this.accountService.changeName(name$);
        } else {
          this.notification.create(
            'error',
            'Cập nhật thông tin tài khoản thất bại',
            res.message
          );
        }
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Cập nhật thông tin tài khoản thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  reset() {
    this.form.reset();
    this.avatar = [];
    this.loadData();
  }

  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Upload ${field}`,
      nzContent: UploaderComponent,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      }
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe(changeParam => {
        if (changeParam.type === 'success') {
          const data = {
            name: changeParam.file.name,
            type: changeParam.file.type,
            url: changeParam.file.response.url,
          };
          const body = {
            title: changeParam.file.name,
            type: changeParam.file.type,
            listUrl: [changeParam.file.response.url]
          };
          // avatar,cover
          this[field] = [];
          this[field].push(data);
          this.form.get('avatar').setValue(changeParam.file.response.url);
        }
      });
      modal.getContentComponent().done.pipe(takeUntil(this.unsubscribe$)).subscribe(changeParam => {
        modal.close();
      });
    });
  }
  onRemoveFile(field: string, index: number) {
    this[field].splice(index, 1);
    this.form.get('avatar').setValue('');
  }
}
